import { render, staticRenderFns } from "./LayerRender.vue?vue&type=template&id=0af359e4&"
import script from "./LayerRender.vue?vue&type=script&lang=ts&"
export * from "./LayerRender.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports